import { render, staticRenderFns } from "./Step7.vue?vue&type=template&id=d8bf56aa&"
import script from "./Step7.vue?vue&type=script&lang=ts&"
export * from "./Step7.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports